import { render, staticRenderFns } from "./TabSettlement.vue?vue&type=template&id=42b32292"
import script from "./TabSettlement.vue?vue&type=script&lang=js"
export * from "./TabSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports